var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("script", { attrs: { type: "application/ld+json" } }, [
    _vm._v("\n    " + _vm._s(_vm.jsonLd) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }